
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isLoadingRefreshToken: false,
    isRefreshApi: false,
};

const tokenSlice = createSlice({
    name: 'token',
    initialState,
    reducers: {
        updateIsLoadingRefreshToken: (state, payload) => {
            state.isLoadingRefreshToken = payload.payload;
        },

    },
});

export const { updateIsLoadingRefreshToken } = tokenSlice.actions;

export default tokenSlice.reducer;
